const ARAL_CLIENT_ID = Number(process.env.REACT_APP_ARAL_CLIENT_ID);

export const isAralDeClientId = (clientId: number): boolean => {
    return clientId === ARAL_CLIENT_ID;
}